import request from "@/utils/request";
import plaintextrequest from "@/utils/plaintextrequest";

// 试玩任务主页
export function Trial(data) {
  // console.log(data);
  return plaintextrequest({
    url: "/Task/Trial",
    method: "post",
    data,
  });
}

// 领取任务
export function getTrial(data) {
  // console.log('领任务传的数据--------------',data);  
  return request({
    url: "/Task/getTrial",
    method: "post",
    data,
  });
}

//领取任务奖励
export function achieveTrial(data) {
  return request({
    url: "/Task/achieveTrial",
    method: "post",
    data,
  });
}



// 福利码兑换记录
export function getGiftRecord(data) {
  return plaintextrequest({
    url: "task/activeyelog",
    method: "post",
    data,
  });
}

// 试玩记录
export function logInfo(data) {
  return plaintextrequest({
    url: "/Task/logInfo",
    method: "post",
    data,
  });
}
